<script setup>
  import RadioControl from '@/components/RadioControl.vue';

  const model = defineModel();

  const options = {
    30: 'Every 30 Mins',
    60: 'Every 60 Mins',
    120: 'Every 2 Hours',
    360: 'Every 6 Hours',
    720: 'Every 12 Hours',
    1440: 'Once a Day'
  };
</script>

<template>
  <div class="jwx-modal__section">
    <div class="jwx-modal__section-body">
      <ul class="jwx-block jwx-table-view" data-surface="1">
        <li v-for="(label, value) in options" :key="value" class="jwx-table-view__row">
          <div class="jwx-table-view__row-content">
            <label :for="'frequency-' + value" class="jwx-table-view__row-label">{{ label }}</label>
            <div class="jwx-table-view__row-actions">
              <RadioControl
                v-model="model"
                name="frequency"
                :id="'frequency-' + value"
                :value="Number(value)"
                :srLabel="'Select ' + label"
              />
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
